var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSalesforce = function SvgSalesforce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.4 6.2c.7-1.4 2.1-2.3 3.7-2.3 1.9 0 3.5 1.2 4.1 2.9.5-.2 1-.3 1.5-.3 2.2 0 4 1.8 4 4.1S22 15 19.7 15H6.9C4.2 15 2 12.8 2 10.1c0-2.4 1.7-4.3 4-4.7.7-1.8 2.4-3 4.4-3 .5 0 1 .1 1.5.2-.3.5-.5 1-.5 1.6z"
  })));
};
export default SvgSalesforce;